// Keys that must survive logout (device-level preferences, not session data)
const PERSISTENT_KEYS = ['hasSeenStartGuide'];

// Clears all localStorage data except PERSISTENT_KEYS
export const clearSession = () => {
  const kept = PERSISTENT_KEYS
    .map((key) => [key, localStorage.getItem(key)])
    .filter(([, value]) => value !== null);

  localStorage.clear();

  kept.forEach(([key, value]) => localStorage.setItem(key, value));
};
